const styles = theme => ({
  placeholderSlider: {
    height: "calc(100vh - 120px - 60px)"
  }
});

export default styles;
